<div class="ui-g" id="actionAddForm">
  <div>
    <h3>{{ 'audit.addNewAction' | translate }}</h3>
    <!-- TODO: traduzioni -->

    <div class="ui-g-12 ui-md-12 flex-align-center">
      <div class="ui-g-12 ui-md-4" [ngClass]="{ 'disabled-container': auditRuleDtEditlId }">
        <label class="top-label" [ngClass]="{'required': true}">{{'audit.ruleType' | translate}}</label>
        <div>
          <p-dropdown [style]="{'width':'80%'}" [options]="actionsTypeCombo" [filter]="false"
            [(ngModel)]="selectedRuleAction" placeholder="{{'common.select_something' | translate}}"
            (onChange)="loadJsonSchema($event)" [disabled]="auditRuleDtEditlId || readOnly">
          </p-dropdown>
        </div>
      </div>

      <div class="ui-g-12 ui-md-4">
        <label class="top-label required" for="date_start">{{'audit.startRuleTypeAction' | translate}}</label>
        <app-kv-calendar #date_start [formData]="formGroup" [inputName]="'date_start'" [startDateSelector]="true"
          [startDateSelector]="true" [endDateInputName]="'date_end'" [endDateCalendar]="date_end" [disabled]="readOnly || isCustMovementEdit">
        </app-kv-calendar>
      </div>

      <div class="ui-g-12 ui-md-4">
        <label class="top-label required" for="date_end">{{'audit.endRuleTypeAction' | translate}}</label>
        <app-kv-calendar #date_end [formData]="formGroup" [inputName]="'date_end'" [startDateSelector]="true"
          [endDateInputName]="'date_end'" [startDateCalendar]="date_start" [endDateCalendar]="date_end" [disabled]="readOnly || isCustMovementEdit">
        </app-kv-calendar>
      </div>
    </div>

    <div class="ui-g-12 ui-md-12 flex-align-center">
      <div class="ui-g-12 ui-md-12">
        <label class="top-label required" for="descr_rule">{{'audit.descrRuleAction' | translate}}</label>
        <div>
          <input class="ui-g-12 ui-md-12" name="descr_rule" #descr_rule type="text" pInputText required [disabled]="readOnly || isCustMovementEdit" />
        </div>
      </div>
    </div>
  </div>



  <div id="clusterAction" *ngIf="show.cluster">

    <div class="ui-g-12 ui-md-10 flex-align-center">
      <div class="ui-g-12 ui-md-10">
        <app-form-fields #cluster *ngIf="formSchema.form.cluster || fieldModel.cluster"
          [fieldSchema]="formSchema.form.cluster" [(fieldModel)]="fieldModel.cluster" [filterable]="true"
          [options]="effectiveClusterOption" [optionLabel]="'label'" [placeholder]="'audit.select_cluster' | translate"
          [disabled]="readOnly">
        </app-form-fields>
      </div>
    </div>
    <div class="ui-g-12 ui-md-10 flex-align-center">
      <div class="ui-g-12 ui-md-2">
        <app-form-fields #cluster_add *ngIf="formSchema.form.cluster_add || fieldModel.cluster_add"
          [fieldSchema]="formSchema.form.cluster_add" [(fieldModel)]="fieldModel.cluster_add" [optionLabel]="'label'"
          (checkboxChanged)="onChangeClusterActionAdd($event)" [disabled]="readOnly">
        </app-form-fields>
      </div>
      <div class="ui-g-12 ui-md-2">
        <app-form-fields #cluster_delete *ngIf="formSchema.form.cluster_delete || fieldModel.cluster_delete"
          [fieldSchema]="formSchema.form.cluster_delete" [(fieldModel)]="fieldModel.cluster_delete" [type]="radio"
          [optionLabel]="'label'" (checkboxChanged)="onChangeClusterActionDelete($event)" [disabled]="readOnly">
        </app-form-fields>
      </div>
      <div class="ui-g-12 ui-md-4">
        <app-form-fields #cluster_start [fieldSchema]="formSchema.form.cluster_start"
          [(fieldModel)]="fieldModel.cluster_start" [optionLabel]="'label'" [disabled]="readOnly">
        </app-form-fields>
      </div>
      <div class="ui-g-12 ui-md-4">
        <app-form-fields #cluster_end [fieldSchema]="formSchema.form.cluster_end"
          [(fieldModel)]="fieldModel.cluster_end" [optionLabel]="'label'" [disabled]="readOnly">
        </app-form-fields>
      </div>
    </div>
  </div>

  <div class="ui-g-12 ui-md-12 flex-align-center" id="acmAction" *ngIf="show.acm">
    <div class="ui-g-12 ui-md-4">
      <app-form-fields #acm [fieldSchema]="formSchema.form.acm" [(fieldModel)]="fieldModel.acm" [options]="acmList"
        [optionLabel]="'label'" [filterable]="true" (fieldModelChange)="onChangeAcm($event)"
        [placeholder]="'audit.selectAcm' | translate" [disabled]="readOnly">
      </app-form-fields>
    </div>
    <div class="ui-g-12 ui-md-3">
      <app-form-fields #acm_val [fieldSchema]="formSchema.form.acm_val" [(fieldModel)]="fieldModel.acm_val" [disabled]="readOnly">
      </app-form-fields>
    </div>
    <div class="ui-g-12 ui-md-4" *ngIf="listReasonsFiltered.length > 0 || fieldModel.acm_reason">
      <app-form-fields #acm_reason [fieldSchema]="formSchema.form.acm_reason" [(fieldModel)]="fieldModel.acm_reason"
        [options]="listReasonsFiltered" [filterable]="true" [optionLabel]="'label'"
        [placeholder]="'common.select_something' | translate" [disabled]="readOnly">
      </app-form-fields>
    </div>
  </div>


  <div class="ui-g-12" id="amazonAction" *ngIf="amazonOption && amazonOption.length > 1">
    <div class="ui-g-12">
      <app-form-fields #amazon [fieldSchema]="formSchema.form.amazon" [(fieldModel)]="fieldModel.amazon"
        [filterable]="true" [optionLabel]="'label'" [options]="amazonOption" [disabled]="readOnly">
      </app-form-fields>
    </div>

  </div>

  <div class="ui-g-12" id="kafkaAction" *ngIf="kafkaOption && kafkaOption.length > 1">
    <div class="ui-g-12">
      <app-form-fields #kafka [fieldSchema]="formSchema.form.kafka" [(fieldModel)]="fieldModel.kafka"
        [optionLabel]="'label'" [filterable]="true" [options]="kafkaOption" [disabled]="readOnly">
      </app-form-fields>
    </div>

  </div>

  <div class="ui-g-12" id="magnewsAction" *ngIf=" magnewsOption && magnewsOption.length > 1">
    <div class="ui-g-12">
      <app-form-fields #magnews [fieldSchema]="formSchema.form.magnews" [(fieldModel)]="fieldModel.magnews"
        [filterable]="true" [optionLabel]="'label'" [options]="magnewsOption" [disabled]="readOnly">
      </app-form-fields>
    </div>
  </div>

  <div class="ui-g-12" id="kncRestAction" *ngIf="kncRestOption && kncRestOption.length > 1">

    <div class="ui-g-12 ui-md-10 flex-align-center">
      <div class="ui-g-12 ui-md-10">
        <app-form-fields #cluster *ngIf="formSchema.form.cluster || fieldModel.cluster"
          [fieldSchema]="formSchema.form.cluster" [(fieldModel)]="fieldModel.cluster" [filterable]="true"
          [options]="effectiveClusterOption" [optionLabel]="'label'" [placeholder]="'audit.select_cluster' | translate">
        </app-form-fields>
      </div>
    </div>
    <div class="ui-g-12 ui-md-10 flex-align-center">
      <div class="ui-g-12 ui-md-2">
        <app-form-fields #cluster_add *ngIf="formSchema.form.cluster_add || fieldModel.cluster_add"
          [fieldSchema]="formSchema.form.cluster_add" [(fieldModel)]="fieldModel.cluster_add" [optionLabel]="'label'"
          (checkboxChanged)="onChangeClusterActionAdd($event)" [disabled]="readOnly">
        </app-form-fields>
      </div>
      <div class="ui-g-12 ui-md-2">
        <app-form-fields #cluster_delete *ngIf="formSchema.form.cluster_delete || fieldModel.cluster_delete"
          [fieldSchema]="formSchema.form.cluster_delete" [(fieldModel)]="fieldModel.cluster_delete" [type]="radio"
          [optionLabel]="'label'" (checkboxChanged)="onChangeClusterActionDelete($event)" [disabled]="readOnly">
        </app-form-fields>
      </div>
      <div class="ui-g-12 ui-md-4">
        <app-form-fields #cluster_start [fieldSchema]="formSchema.form.cluster_start"
          [(fieldModel)]="fieldModel.cluster_start" [optionLabel]="'label'" [disabled]="readOnly">
        </app-form-fields>
      </div>
      <div class="ui-g-12 ui-md-4">
        <app-form-fields #cluster_end [fieldSchema]="formSchema.form.cluster_end"
          [(fieldModel)]="fieldModel.cluster_end" [optionLabel]="'label'" [disabled]="readOnly">
        </app-form-fields>
      </div>
    </div>
    <div class="ui-g-12">
      <app-form-fields #kncRest [fieldSchema]="formSchema.form.kncRest" [(fieldModel)]="fieldModel.kncRest"
        [filterable]="true" [optionLabel]="'label'" [options]="kncRestOption" [disabled]="readOnly">
      </app-form-fields>
    </div>
  </div>

  <div class="ui-g-12" id="pushAction" *ngIf="pushOption && pushOption.length > 0">
    <div class="ui-g-12">
      <app-form-fields #push [fieldSchema]="formSchema.form.push" [(fieldModel)]="fieldModel.push" [filterable]="true"
        [optionLabel]="'label'" [options]="pushOption" [disabled]="readOnly">
      </app-form-fields>
    </div>
  </div>
  <div id="custMovement" *ngIf="show.custMovement">
    <div class="ui-g-12 ui-md-12 flex-align-center">
      <div class="ui-g ui-fluid">
        <div class="ui-g-3">
          <app-form-fields #challenge_id
            [fieldSchema]="formSchema.form.challenge_id"
            [(fieldModel)]="fieldModel.challenge_id"
            [optionLabel]="'label'"
            [placeholder]="'common.select_something' | translate"
            [disabled]="readOnly || isCustMovementEdit">
          </app-form-fields>
        </div>
        <div class="ui-g-9">
          <app-form-fields #challenge_description
            [fieldSchema]="formSchema.form.challenge_description"
            [(fieldModel)]="fieldModel.challenge_description"
            [optionLabel]="'label'"
            [placeholder]="'common.select_something' | translate"
            [disabled]="readOnly || isCustMovementEdit">
          </app-form-fields>
        </div>
        <div class="ui-g-6">
          <app-form-fields #start_date
            [fieldSchema]="formSchema.form.start_date"
            [(fieldModel)]="fieldModel.start_date"
            [optionLabel]="'label'"
            [placeholder]="'common.select_something' | translate"
            [disabled]="readOnly || isCustMovementEdit">
          </app-form-fields>
        </div>
        <div class="ui-g-6">
          <app-form-fields #end_date
            [fieldSchema]="formSchema.form.end_date"
            [(fieldModel)]="fieldModel.end_date"
            [optionLabel]="'label'"
            [placeholder]="'common.select_something' | translate"
            [disabled]="readOnly || isCustMovementEdit">
          </app-form-fields>
        </div>
      </div>
    </div>
  </div>

  <!-- Bottoni Indietro e Aggiungi -->
  <div class="buttonsContainer">
    <button pButton type="submit" (click)="onClickClose()" icon="fa fa-chevron-right" iconPos="right"
      class="k-generic-btn footer-btn" label="{{'audit.undoneAction' | translate}}">
    </button>
    <button pButton (click)="closeAddNewAction()" icon="fa fa-chevron-right" iconPos="right" type="button"
      *ngIf="!readOnly && !isCustMovementEdit"
      class="k-generic-btn footer-btn" label="{{'audit.addAction' | translate}}">
    </button>

  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/audit/rules/add-rule/audit-action/audit-new-action/audit-new-action.component.html